import { useState, useEffect } from "react";
import { themes } from "./Themes";


export default function ThemeSwitcher() {
  const storedColors = localStorage.getItem("customColors");
  const initialColors = storedColors ? JSON.parse(storedColors) : themes[0].colors;

  const [customColors, setCustomColors] = useState<Record<string, string>>(initialColors);

  // Atualiza as variáveis CSS no documento
  useEffect(() => {
    Object.entries(customColors).forEach(([key, value]) => {
      document.documentElement.style.setProperty(`--${key}`, value);
    });
    localStorage.setItem("customColors", JSON.stringify(customColors));
  }, [customColors]);

  // Função para trocar todas as cores ao selecionar um tema
  const applyTheme = (themeName: string) => {
    const selectedTheme = themes.find(t => t.name === themeName);
    if (selectedTheme) {
      console.log(selectedTheme.colors);
      setCustomColors(selectedTheme.colors);
      setSelectedThemeName(themeName);
      // Copia o nome do tema para a área de transferência
      navigator.clipboard.writeText(themeName)
        .then(() => {
          console.log(`Tema "${themeName}" copiado para a área de transferência.`);
        })
        .catch(err => {
          console.error("Erro ao copiar nome do tema:", err);
        });
    }
  };

  // Função para atualizar cor individualmente
  const handleColorChange = (variable: string, value: string) => {
    setCustomColors((prev) => ({
      ...prev,
      [variable]: value
    }));
  };

  const [selectedThemeName, setSelectedThemeName] = useState<string | null>(null);

  return (
    <div>
      <div className="collapse">
        <input type="radio" name="my-accordion-1" />
        <div className="collapse-title text-xl font-medium">Temas</div>
        <div className="collapse-content">
          <div className="colors-scroll">
            {themes.map(({ name, colors }) => {
              const isSelected = selectedThemeName === name;
              return (
                <button
                  key={name}
                  title={name}
                  className={`w-9 h-9 rounded-lg border-2 transition-transform transform hover:scale-110 ${
                    isSelected ? "border-blue-500 ring-2 ring-blue-300" : "border-gray-200"
                  }`}
                  type="button"
                  style={{
                    background: `linear-gradient(
                      180deg,
                      ${colors['color-primary']} 0%,
                      ${colors['color-primary']} 15%,
                      ${colors['color-secondary']} 15%,
                      ${colors['color-secondary']} 30%,
                      ${colors['color-background']} 30%,
                      ${colors['color-background']} 60%,
                      ${colors['color-tab-primary']} 60%,
                      ${colors['color-tab-primary']} 75%,
                      ${colors['color-tab']} 75%,
                      ${colors['color-tab']} 100%
                    )`,
                  }}
                  onClick={() => applyTheme(name)}
                />
              );
            })}
          </div>
        </div>
      </div>
      <div className="collapse">
        <input type="radio" name="my-accordion-1" />
        <div className="collapse-title text-xl font-medium">Personalizar cores</div>
        <div className="collapse-content">
          <div className="colors-scroll">
            <p className="font-bold mt-4">Geral</p>
            <div className="mt-2">
              <label className="block text-sm font-medium">Fundo central</label>
              <input
                type="color"
                value={customColors["color-background-center"] || ""}
                onChange={(e) => handleColorChange("color-background-center", e.target.value)}
                className="mt-1 w-full"
              />
            </div>
            <div className="mt-2">
              <label className="block text-sm font-medium">Fundo lateral</label>
              <input
                type="color"
                value={customColors["color-background"] || ""}
                onChange={(e) => handleColorChange("color-background", e.target.value)}
                className="mt-1 w-full"
              />
            </div>
            <div className="mt-2">
              <label className="block text-sm font-medium">Texto</label>
              <input
                type="color"
                value={customColors["color-text"] || ""}
                onChange={(e) => handleColorChange("color-text", e.target.value)}
                className="mt-1 w-full"
              />
            </div>
            <div className="mt-2">
              <label className="block text-sm font-medium">Títulos e Botões</label>
              <input
                type="color"
                value={customColors["color-secondary"] || ""}
                onChange={(e) => handleColorChange("color-secondary", e.target.value)}
                className="mt-1 w-full"
              />
            </div>
            <div className="mt-2">
              <label className="block text-sm font-medium">Texto dos Botões</label>
              <input
                type="color"
                value={customColors["color-on-secondary"] || ""}
                onChange={(e) => handleColorChange("color-on-secondary", e.target.value)}
                className="mt-1 w-full"
              />
            </div>
            <div className="mt-2">
              <label className="block text-sm font-medium">Menos destaque</label>
              <input
                type="color"
                value={customColors["color-secondary-container"] || ""}
                onChange={(e) => handleColorChange("color-secondary-container", e.target.value)}
                className="mt-1 w-full"
              />
            </div>
            <div className="mt-2">
              <label className="block text-sm font-medium">Fundo secundário</label>
              <input
                type="color"
                value={customColors["color-canvas"] || ""}
                onChange={(e) => handleColorChange("color-canvas", e.target.value)}
                className="mt-1 w-full"
              />
            </div>
            

            <hr className="mt-5 mb-5"/>
            <p className="font-bold mt-4">Barra Superior e Menu</p>
            <div className="mt-2">
              <label className="block text-sm font-medium">Fundo</label>
              <input
                type="color"
                value={customColors["color-primary"] || ""}
                onChange={(e) => handleColorChange("color-primary", e.target.value)}
                className="mt-1 w-full"
              />
            </div>
            {/* On Primary */}
            <div className="mt-2">
              <label className="block text-sm font-medium">Primária - Texto e Ícones</label>
              <input
                type="color"
                value={customColors["color-on-primary"] || ""}
                onChange={(e) => handleColorChange("color-on-primary", e.target.value)}
                className="mt-1 w-full"
              />
            </div>
            {/* Primary Light */}
            <div className="mt-2">
              <label className="block text-sm font-medium">Secundária</label>
              <input
                type="color"
                value={customColors["color-primary-light"] || ""}
                onChange={(e) => handleColorChange("color-primary-light", e.target.value)}
                className="mt-1 w-full"
              />
            </div>


            {/* Primary Container */}
            <div className="mt-2">
              <label className="block text-sm font-medium">Aba ativa</label>
              <input
                type="color"
                value={customColors["color-primary-container"] || ""}
                onChange={(e) => handleColorChange("color-primary-container", e.target.value)}
                className="mt-1 w-full"
              />
            </div>
            <hr className="mt-5 mb-5"/>
            <p className="font-bold mt-4">Seções de conteúdo</p>
            <div className="mt-2">
              <label className="block text-sm font-medium">Títulos e botões de seções</label>
              <input
                type="color"
                value={customColors["color-hint"] || ""}
                onChange={(e) => handleColorChange("color-hint", e.target.value)}
                className="mt-1 w-full"
              />
            </div>
            <div className="mt-2">
              <label className="block text-sm font-medium">Títulos de conteúdo</label>
              <input
                type="color"
                value={customColors["color-highlight"] || ""}
                onChange={(e) => handleColorChange("color-highlight", e.target.value)}
                className="mt-1 w-full"
              />
            </div>


            <hr className="mt-5 mb-5"/>
            <p className="font-bold mt-4">Caixas de conteúdo</p>
            {/* Surface */}
            <div className="mt-2">
              <label className="block text-sm font-medium">Fundo</label>
              <input
                type="color"
                value={customColors["color-surface"] || ""}
                onChange={(e) => handleColorChange("color-surface", e.target.value)}
                className="mt-1 w-full"
              />
            </div>
            {/* On Surface */}
            <div className="mt-2">
              <label className="block text-sm font-medium">Ícones e textos</label>
              <input
                type="color"
                value={customColors["color-on-surface"] || ""}
                onChange={(e) => handleColorChange("color-on-surface", e.target.value)}
                className="mt-1 w-full"
              />
            </div>


            <hr className="mt-5 mb-5"/>
            <p className="font-bold mt-4">Diversos</p>
            {/* BG */}
            <div className="mt-2">
              <label className="block text-sm font-medium">Fundo tocando agora</label>
              <input
                type="color"
                value={customColors["color-bg"] || ""}
                onChange={(e) => handleColorChange("color-bg", e.target.value)}
                className="mt-1 w-full"
              />
            </div>
            <div className="mt-2">
              <label className="block text-sm font-medium">Texto tocando agora</label>
              <input
                type="color"
                value={customColors["color-on-bg"] || ""}
                onChange={(e) => handleColorChange("color-on-bg", e.target.value)}
                className="mt-1 w-full"
              />
            </div>
            {/* Divider */}
            <div className="mt-2">
              <label className="block text-sm font-medium">Borda interruptor</label>
              <input
                type="color"
                value={customColors["color-divider"] || ""}
                onChange={(e) => handleColorChange("color-divider", e.target.value)}
                className="mt-1 w-full"
              />
            </div>
            {/* Shimmer */}
            <div className="mt-2">
              <label className="block text-sm font-medium">Efeito de carregamento</label>
              <input
                type="color"
                value={customColors["color-shimmer"] || ""}
                onChange={(e) => handleColorChange("color-shimmer", e.target.value)}
                className="mt-1 w-full"
              />
            </div>


            <hr className="mt-5 mb-5"/>
            <p className="font-bold mt-4">Navegação</p>
            {/* Tab */}
            <div className="mt-2">
              <label className="block text-sm font-medium">Fundo</label>
              <input
                type="color"
                value={customColors["color-tab"] || ""}
                onChange={(e) => handleColorChange("color-tab", e.target.value)}
                className="mt-1 w-full"
              />
            </div>
            {/* Tab Primary */}
            <div className="mt-2">
              <label className="block text-sm font-medium">Primária</label>
              <input
                type="color"
                value={customColors["color-tab-primary"] || ""}
                onChange={(e) => handleColorChange("color-tab-primary", e.target.value)}
                className="mt-1 w-full"
              />
            </div>
            {/* On Tab */}
            <div className="mt-2">
              <label className="block text-sm font-medium">Secundária</label>
              <input
                type="color"
                value={customColors["color-on-tab"] || ""}
                onChange={(e) => handleColorChange("color-on-tab", e.target.value)}
                className="mt-1 w-full"
              />
            </div>
            {/* Tab Shadow */}
            {/* <div className="mt-2">
              <label className="block text-sm font-medium">Sombra Botão Rádio</label>
              <input
                type="color"
                value={customColors["color-tab-shadow"] || ""}
                onChange={(e) => handleColorChange("color-tab-shadow", e.target.value)}
                className="mt-1 w-full"
              />
            </div> */}
          </div>
        </div>
      </div>
    </div>
  );
}
